import { render } from "./SearchCourse.vue?vue&type=template&id=cdc635ea&scoped=true"
import script from "./SearchCourse.vue?vue&type=script&lang=js"
export * from "./SearchCourse.vue?vue&type=script&lang=js"

import "./SearchCourse.vue?vue&type=style&index=0&id=cdc635ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdc635ea"]])

export default __exports__